export class Invite {
	constructor({ email, roles, inviteLink } = {}) {
		this.email = email;
		this.roles = roles;
		this.inviteLink = inviteLink;
	}
}

export class Users {
	/* TODO: Refactor to be generic */
	static getUserType(userGroups) {
		if (userGroups.includes(this.TYPES.PROFESSIONAL)) {
			return this.TYPES.PROFESSIONAL;
		}
		if (userGroups.includes(this.TYPES.COMPANY)) {
			return this.TYPES.COMPANY;
		}
		if (userGroups.includes(this.TYPES.SUPER_ADMIN)) {
			return this.TYPES.SUPER_ADMIN;
		}
	}

	static get TYPES() {
		return USER_TYPES;
	}
}

export const USER_TYPES = {
	PROFESSIONAL: 'Locum',
	COMPANY: 'CompanyAdmin',
	SUPER_ADMIN: 'SuperAdmin',
};
